import axios, { type AxiosInstance } from 'axios'

const config = {
  timeout: 60 * 1000, // 60 secondes
}

const axiosInstance: AxiosInstance = axios.create(config)

// Note: L'injection automatique du token via interceptor a été retirée car elle causait
// des problèmes avec le flux d'authentification MSAL (redirections intempestives).
// Les tokens doivent être ajoutés manuellement via getAxiosTokenConfig() dans chaque action.

// Response interceptor
axiosInstance.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    return Promise.reject(error)
  },
)

// Export pour utilisation globale
export default axiosInstance

// Export nommé pour compatibilité
export { axiosInstance as axios }

// Déclaration globale pour window.axios (optionnel)
declare global {
  interface Window {
    axios: AxiosInstance
  }
}

window.axios = axiosInstance
